import React from 'react';

import { cx } from '@emotion/css';
import { Category, Post, Tag } from '@lib/wordpress.d';

import styles from './BlogList.module.scss';
import { BlogMainArticle } from './BlogMainArticle';
import { CardList } from './CardList';

type Props = {
  posts: Post[];
  categories: Category[];
  tags: Tag[];
  page: number;
  totalPages: number;
  selectedCategory?: string;
};

export const BlogList = (props: Props) => {
  const { posts, categories, page, totalPages, selectedCategory, tags } = props;

  const sanitizedCategories = categories.filter((category) =>
    category.name != 'Uncategorized' ? category : null,
  );
  const mainPost = posts?.find((post) => post?.sticky);
  return (
    <div className={styles.root}>
      <div className={styles.blog_wraper}>
        <div className={styles.blog_inner}>
          <div className={styles.container}>
            <div className={styles.source_insights}>
              <h1 className={cx(styles.insights_title, styles.h1)}>
                Expert Care for Your Property
              </h1>
              <p className={cx(styles.insights_subtext, styles.p)}>
                Keep your property safe, compliant, and problem-free with
                <br />
                practical advice and professional insights you can trust. Smart
                maintenance starts here
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1440"
              height="330"
              viewBox="0 0 1440 330"
              fill="none"
              className={cx(
                styles.wave,
                styles.detail_wave,
                styles.blog_list_wave,
              )}>
              <path
                d="M35.3062 7.02353C222.703 35.5011 379.545 107.712 504.816 145.343C837.574 244.209 1031.72 90.9463 1440 0C1440 732.212 1440 359.592 1440 882C960 882 721 882 3.01249e-06 882C2.89477e-06 393.018 -3.70741e-06 459.12 3.01408e-06 2.18378C11.7833 3.57537 23.5538 5.18743 35.3062 7.02353Z"
                fill="#FFFCFA"></path>
            </svg>
          </div>
        </div>
        <div className={styles.blogs_wrap}>
          <div className={cx(styles.container, styles.blogs_wrap_container)}>
            {mainPost && (
              <BlogMainArticle
                styles={styles}
                post={mainPost}
                categories={sanitizedCategories}
              />
            )}
            <CardList
              styles={styles}
              posts={posts}
              categories={sanitizedCategories}
              page={page}
              tags={tags}
              totalPages={totalPages}
              selectedCategory={selectedCategory}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
